/**
 * plugins/vuetify.ts
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
// import "@mdi/font/css/materialdesignicons.css";
import { aliases, mdi } from "vuetify/iconsets/mdi-svg";
import "vuetify/styles";
import colors from "vuetify/util/colors";

// Composables
import { createVuetify, type ThemeDefinition } from "vuetify";
import { changelog } from "@/data/changelog";

const myCustomLightTheme: ThemeDefinition = {
  dark: false,
  colors: {
    background: "#EDEDE1",
    surface: "#FFFFFF",
    primary: "#16577C",
    accent: "#57A098",
    "primary-darken-1": "#3700B3",
    secondary: "#5D7884",
    "secondary-darken-1": "#018786",
    error: "#FF5252",
    info: "#2196F3",
    success: "#57A098",
    warning: "#9A4704",
    vicblue: "#009bff",
    vicyellow: "#D2B468",
    chartColor1: colors.red.darken1,
    chartColor2: colors.yellow.darken1,
    chartColor3: colors.green.darken1,
  },
};

const myCustomDarkTheme = {
  dark: true,
  colors: {
    background: "#121212",
    surface: "#1E1E1E",
    primary: "#16577C",
    accent: "#57A098",
    "primary-darken-1": "#3700B3",
    secondary: "#5D7884",
    "secondary-darken-1": "#018786",
    error: "#CF6679",
    info: "#2196F3",
    success: "#57A098",
    warning: "#FBC02D",
    vicblue: "#009bff",
    vicyellow: "#D2B468",
  },
};

// Nieuw: kerst theme, gebaseerd op dark maar met duidelijke kerstkleuren
const kerstTheme: ThemeDefinition = {
  dark: true,
  colors: {
    background: "#0B1722",
    surface: "#182430",
    primary: "#166534",          // donkergroen
    "primary-darken-1": "#14532d",
    secondary: "#b91c1c",        // warm rood
    "secondary-darken-1": "#7f1d1d",
    accent: "#facc15",           // goud
    error: "#f97373",
    info: "#38bdf8",
    success: "#22c55e",
    warning: "#facc15",
    vicblue: "#15803d",
    vicyellow: "#facc15",
  },
};

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
  icons: {
    defaultSet: "mdi",
    aliases,
    sets: {
      mdi,
    },
  },
  theme: {
    defaultTheme: "myCustomLightTheme",
    themes: {
      myCustomLightTheme,
      myCustomDarkTheme,
      kerstTheme, // registreer het nieuwe theme
    },
  },
});
